import { render, staticRenderFns } from "./ListOrganizationPage.vue?vue&type=template&id=7e769f4a"
import script from "./ListOrganizationPage.vue?vue&type=script&lang=js"
export * from "./ListOrganizationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports